import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { LOGIN_PATH } from '../lib/hubPath'
import { pubImg } from '../lib/pubImg'

type RecoveryInfo = {
  recovery_auto?: boolean
  wa_url?: string
  subtitle?: string
}

const FALLBACK_WA =
  'https://wa.me/5561991477997?text=' + encodeURIComponent('RECUPERAR SENHA')

export function ForgotPasswordPage() {
  const [info, setInfo] = useState<RecoveryInfo | null>(null)
  const [error, setError] = useState('')

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      try {
        const res = await fetch('/api/v1/auth/recovery', { credentials: 'same-origin' })
        const json = (await res.json()) as { success?: boolean; data?: RecoveryInfo; message?: string }
        if (!res.ok || !json.success || !json.data?.wa_url) {
          throw new Error(json.message || 'Não foi possível carregar a recuperação.')
        }
        if (!cancelled) setInfo(json.data)
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : 'Falha ao carregar.')
          setInfo({
            recovery_auto: true,
            wa_url: FALLBACK_WA,
            subtitle:
              'Envie RECUPERAR SENHA pelo WhatsApp, usando o número cadastrado na sua conta.',
          })
        }
      }
    })()
    return () => {
      cancelled = true
    }
  }, [])

  const waUrl = info?.wa_url || FALLBACK_WA
  const subtitle =
    info?.subtitle ||
    'Envie RECUPERAR SENHA pelo WhatsApp, usando o número cadastrado na sua conta.'

  return (
    <div className="hub-login-shell">
      <div className="hub-login-shell__pattern" aria-hidden="true">
        <img src={pubImg('images/modern.svg')} alt="" />
      </div>

      <div className="hub-login-form-col">
        <div className="hub-login-card">
          <a href="https://eleitorweb.com.br" className="hub-login-logo" title="EleitorWEB">
            <img
              src={pubImg('images/eleitorweb-300.png')}
              alt="EleitorWEB"
              onError={(e) => {
                e.currentTarget.src = pubImg('images/logo-light.png')
              }}
            />
          </a>

          <p className="bp-card__eyebrow">Base Política</p>
          <h1 className="hub-login-title">Recuperar senha</h1>
          <p className="bp-muted hub-login-subtitle">{subtitle}</p>

          <div className="bp-card hub-forgot-steps" style={{ textAlign: 'left', marginBottom: '1rem' }}>
            <p className="bp-card__eyebrow" style={{ marginBottom: '0.5rem' }}>
              Como recuperar
            </p>
            <ol className="bp-muted" style={{ margin: 0, paddingLeft: '1.25rem' }}>
              <li>Toque no botão abaixo.</li>
              <li>Envie a mensagem pelo número cadastrado na sua conta.</li>
              <li>
                {info?.recovery_auto === false
                  ? 'A equipe responde nesta conversa.'
                  : 'O sistema devolve uma senha provisória nesta conversa.'}
              </li>
            </ol>
          </div>

          {error ? (
            <p className="bp-muted" style={{ fontSize: '0.8rem', marginBottom: '0.75rem' }}>
              {error} Usando o WhatsApp padrão.
            </p>
          ) : null}

          <a
            className="bp-btn bp-btn--primary"
            href={waUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{ width: '100%', marginBottom: '0.75rem' }}
          >
            Recuperar senha pelo WhatsApp
          </a>

          <p className="bp-muted hub-login-classic">
            <Link to={LOGIN_PATH}>Voltar ao login</Link>
          </p>
        </div>
      </div>

      <aside className="hub-login-promo" aria-label="Ajuda">
        <img
          src={pubImg('images/logo-dark.png')}
          alt="EleitorWEB"
          className="hub-login-promo__logo"
        />
        <h2 className="hub-login-promo__title">Esqueceu a senha?</h2>
        <p className="hub-login-promo__desc">
          A recuperação é pelo WhatsApp do suporte, com o mesmo número cadastrado na conta — sem
          formulário de e-mail.
        </p>
      </aside>
    </div>
  )
}
